var _style, _g, _g2, _g3, _g4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarker2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    style: {
      enableBackground: "new 0 0 720 720"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;fill:#28C0E8;}\n\t.st2{display:inline;fill:#231F20;}\n\t.st3{display:inline;fill:#EC1C24;}\n\t.st4{display:inline;fill:#9F5DA4;}\n\t.st5{fill:#0071BB;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M718.8,359.1c0,198.3-160.7,359.1-359.1,359.1C161.5,718.2,0.6,557.4,0.6,359.1C0.6,160.8,161.5,0,359.7,0 C558.1,0,718.8,160.8,718.8,359.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "248.9,538.7 248.9,179 485.8,179 485.8,241.6 319.1,241.6 319.1,326 461,326 461,388.6 319.1,388.6  319.1,476.1 485.8,476.1 485.8,538.7  "
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M720,360c0,198.8-161.1,360-360,360C161.3,720,0,558.8,0,360C0,161.2,161.3,0,360,0C558.9,0,720,161.2,720,360 "
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M720,360c0,198.8-161.1,360-360,360C161.3,720,0,558.7,0,360C0,161.2,161.3,0,360,0C558.9,0,720,161.2,720,360 "
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M720,360c0,198.8-161.1,360-360,360C161.3,720,0,558.8,0,360C0,161.2,161.3,0,360,0C558.9,0,720,161.2,720,360 "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker2);
export default __webpack_public_path__ + "static/media/marker2.1b186be64cd5a14743005937f99e8e42.svg";
export { ForwardRef as ReactComponent };